import { Box, Button, Typography } from "@mui/material";
import theme from "assets/styles/themes";
import { getLD13, getLD13Filters, LD13Chart, setLD13Filters } from "store/slice/charts";
import { LegendItem } from "../LegendItem";
import useChartSlice from "store/slice/charts/useChartSlice";
import { memo } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import useTenureLegend from "../../useTenureLegend";

const Legend = memo(function Legend() {
    const dispatch = useAppDispatch();

    const tenureChartData = useChartSlice(getLD13) as LD13Chart;
    const LD13SelectedLegend = useAppSelector(getLD13Filters)?.LD13SelectedLegend;

    const { usersData, sharedHistoriesData } = useTenureLegend(tenureChartData);

    const handleLegendClick = (id: string, type: "personId" | "overlapingId") => {
        if (LD13SelectedLegend?.id === id) {
            dispatch(setLD13Filters({ LD13SelectedLegend: { ...LD13SelectedLegend, id: "" } }));
            return;
        }
        dispatch(setLD13Filters({ LD13SelectedLegend: { id, type } }));
    };

    return (
        <Box>
            {Boolean(usersData.length) && (
                <Box sx={{ mb: 2 }}>
                    <Typography
                        component="h3"
                        sx={{
                            fontWeight: 600,
                            fontSize: 12,
                            mb: 1,
                            color: theme.palette.text.disabled,
                            textTransform: "uppercase",
                        }}
                    >
                        Key
                    </Typography>
                    {usersData?.map((user) => {
                        const opacity = !LD13SelectedLegend?.id || LD13SelectedLegend.id === user.personId;
                        const label = `${user.name}, ${user.role}`;

                        return (
                            <Button
                                key={user.id}
                                sx={{
                                    display: "block",
                                    textTransform: "none",
                                    height: "auto",
                                    padding: 0,
                                    opacity: opacity ? 1 : 0.5,
                                }}
                                onClick={() => handleLegendClick(user.personId, "personId")}
                            >
                                <LegendItem
                                    color={theme.palette.button.active.from}
                                    label={label}
                                    type="userIcon"
                                    sx={{ mb: 1 }}
                                />
                            </Button>
                        );
                    })}
                </Box>
            )}

            {Boolean(sharedHistoriesData.length) && (
                <Box>
                    <Typography
                        component="h3"
                        sx={{
                            fontWeight: 600,
                            fontSize: 12,
                            mb: 1,
                            color: theme.palette.text.disabled,
                            textTransform: "uppercase",
                        }}
                    >
                        Shared histories
                    </Typography>
                    {sharedHistoriesData.map((data) => {
                        const { id, color, name, companyName } = data;
                        const opacity = !LD13SelectedLegend?.id || LD13SelectedLegend.id === data.id;

                        return (
                            <Button
                                key={data.id}
                                sx={{
                                    display: "block",
                                    textTransform: "none",
                                    height: "auto",
                                    padding: 0,
                                    textAlign: "left",
                                    opacity: opacity ? 1 : 0.5,
                                }}
                                onClick={() => handleLegendClick(data.id, "overlapingId")}
                            >
                                <LegendItem key={id} color={color} label={name} subLabel={companyName} type="square" />
                            </Button>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
});

export default Legend;
